'use strict';

import angular from 'angular';

import uiRouter from 'angular-ui-router';

import routing from './apps.routes';

import list from './list';
import show from './show';
import add from './add';
import edit from './edit';

export default angular.module('updateServerApp.apps', [uiRouter, list, show, add, edit])
  .config(routing)
  .run(function($rootScope) {
    'ngInject';

    $rootScope.$on('$stateChangeStart', function(event, next, nextParams, current) {
      if(next.name === 'logout' && current && current.name && !current.authenticate) {
        next.referrer = current.name;
      }
    });
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/apps/index.js